import Blueprint from '../src/Blueprint';
export default Blueprint;
